const WISHLIST_KEY = 'oaa:wishlist';

function readWishlist() {
  try {
    const parsed = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

class OaaWishlistPage extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-wishlist-track]');
    this.empty = this.querySelector('[data-wishlist-empty]');
    this.render();
    document.addEventListener('oaa:wishlist:change', this.onChange);
  }

  disconnectedCallback() {
    document.removeEventListener('oaa:wishlist:change', this.onChange);
  }

  onChange = () => {
    const active = new Set(readWishlist());
    this.track?.querySelectorAll('[data-recent-card]').forEach((card) => {
      if (!active.has(card.dataset.productHandle)) card.remove();
    });
    this.toggleState();
  };

  async render() {
    if (!this.track) return;
    const handles = readWishlist().slice(0, 24);
    const cards = await Promise.all(handles.map(async (handle) => {
      try {
        const url = '/products/' + encodeURIComponent(handle) + '?section_id=oaa-recently-viewed-card';
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) return null;
        const html = await response.text();
        return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recent-card]');
      } catch {
        return null;
      }
    }));
    cards.filter(Boolean).forEach((card) => this.track.append(card));
    this.toggleState();
  }

  toggleState() {
    const hasItems = Boolean(this.track?.children.length);
    this.closest('.oaa-wishlist-page')?.setAttribute('data-ready', String(hasItems));
    if (this.empty) this.empty.hidden = hasItems;
  }
}

if (!customElements.get('oaa-wishlist-page')) customElements.define('oaa-wishlist-page', OaaWishlistPage);
